import React from "react";
import { Button, Col, Label, Row } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import {
  serviceCaller,
  ServiceCallerProps,
  withLoginRedirect,
} from "../../composition";
import { isCurrentUserAdmin } from "../../../utils/roleCheck";
import {
  GlobalThankYouAdminsBlock,
  SegmentThankYouAdminsBlock,
  UserThankYouAssignmentBlock,
} from "./index";
import s from "./styles.scss";

function ThankYouAdminPageChrome(props: {
  title: string;
  onBack: () => void;
  action?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <main className={s.main}>
      <div className={s.container}>
        <Row>
          <Col md={{ size: 8, offset: 2 }} sm={12} className={s.noPadding}>
            <div onClick={props.onBack} className={s.cursor}>
              <div className={s.arrowLeftContainer}>
                <div className={s.arrowLeft} />
              </div>
              <Label className={s.backLabel}>Back</Label>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={{ size: 8, offset: 2 }} sm={12}>
            <div className={s.pageHeader}>
              <h2 className={s.pageTitle}>{props.title}</h2>
              {props.action}
            </div>
            {props.children}
          </Col>
        </Row>
      </div>
    </main>
  );
}

function AddNewAction(props: {
  to: string;
  onNavigate: (path: string) => void;
}) {
  return (
    <Button className={s.primaryButton} onClick={() => props.onNavigate(props.to)}>
      Add
    </Button>
  );
}

class GlobalThankYouAdminsPageInner extends React.Component<ServiceCallerProps> {
  render() {
    return (
      <ThankYouAdminPageChrome
        title="Thank You Users"
        onBack={() => this.props.navigate("/users")}
        action={
          isCurrentUserAdmin(this.props.currentCharity) ? (
            <AddNewAction
              to="/users/thank-you-admins/new"
              onNavigate={this.props.navigate}
            />
          ) : null
        }
      >
        <GlobalThankYouAdminsBlock hideTitle hideAdd />
      </ThankYouAdminPageChrome>
    );
  }
}

class GlobalThankYouAdminAddPageInner extends React.Component<ServiceCallerProps> {
  render() {
    return (
      <ThankYouAdminPageChrome
        title="Add Thank You User"
        onBack={() => this.props.navigate("/users/thank-you-admins")}
      >
        <GlobalThankYouAdminsBlock
          hideTitle
          addOnly
          onAddSuccess={() => this.props.navigate("/users/thank-you-admins")}
        />
      </ThankYouAdminPageChrome>
    );
  }
}

class SegmentThankYouAdminsPageInner extends React.Component<ServiceCallerProps> {
  render() {
    const segmentId = this.props.params && this.props.params.segmentId;
    if (!segmentId) {
      return null;
    }
    return (
      <ThankYouAdminPageChrome
        title="Thank You Users"
        onBack={() => this.props.navigate(`/segments/${segmentId}`)}
        action={
          isCurrentUserAdmin(this.props.currentCharity) ? (
            <AddNewAction
              to={`/segments/${segmentId}/thank-you-admins/new`}
              onNavigate={this.props.navigate}
            />
          ) : null
        }
      >
        <SegmentThankYouAdminsBlock hideTitle hideAdd segmentId={segmentId} />
      </ThankYouAdminPageChrome>
    );
  }
}

class SegmentThankYouAdminAddPageInner extends React.Component<ServiceCallerProps> {
  render() {
    const segmentId = this.props.params && this.props.params.segmentId;
    if (!segmentId) {
      return null;
    }
    return (
      <ThankYouAdminPageChrome
        title="Add Thank You User"
        onBack={() =>
          this.props.navigate(`/segments/${segmentId}/thank-you-admins`)
        }
      >
        <SegmentThankYouAdminsBlock
          hideTitle
          addOnly
          segmentId={segmentId}
          onAddSuccess={() =>
            this.props.navigate(`/segments/${segmentId}/thank-you-admins`)
          }
        />
      </ThankYouAdminPageChrome>
    );
  }
}

class UserThankYouAssignmentsPageInner extends React.Component<ServiceCallerProps> {
  render() {
    const userId = this.props.params && this.props.params.userId;
    if (!userId) {
      return null;
    }
    return (
      <ThankYouAdminPageChrome
        title="Thank You Users"
        onBack={() => this.props.navigate(`/users/${userId}`)}
        action={
          isCurrentUserAdmin(this.props.currentCharity) ? (
            <AddNewAction
              to={`/users/${userId}/thank-you-admins/new`}
              onNavigate={this.props.navigate}
            />
          ) : null
        }
      >
        <UserThankYouAssignmentBlock hideTitle hideAdd userId={userId} />
      </ThankYouAdminPageChrome>
    );
  }
}

class UserThankYouAssignmentAddPageInner extends React.Component<ServiceCallerProps> {
  render() {
    const userId = this.props.params && this.props.params.userId;
    if (!userId) {
      return null;
    }
    return (
      <ThankYouAdminPageChrome
        title="Add Thank You User"
        onBack={() =>
          this.props.navigate(`/users/${userId}/thank-you-admins`)
        }
      >
        <UserThankYouAssignmentBlock
          hideTitle
          addOnly
          userId={userId}
          onAddSuccess={() =>
            this.props.navigate(`/users/${userId}/thank-you-admins`)
          }
        />
      </ThankYouAdminPageChrome>
    );
  }
}

export const GlobalThankYouAdminsPage = serviceCaller(
  withLoginRedirect(withStyles(s)(GlobalThankYouAdminsPageInner))
);

export const GlobalThankYouAdminAddPage = serviceCaller(
  withLoginRedirect(withStyles(s)(GlobalThankYouAdminAddPageInner))
);

export const SegmentThankYouAdminsPage = serviceCaller(
  withLoginRedirect(withStyles(s)(SegmentThankYouAdminsPageInner))
);

export const SegmentThankYouAdminAddPage = serviceCaller(
  withLoginRedirect(withStyles(s)(SegmentThankYouAdminAddPageInner))
);

export const UserThankYouAssignmentsPage = serviceCaller(
  withLoginRedirect(withStyles(s)(UserThankYouAssignmentsPageInner))
);

export const UserThankYouAssignmentAddPage = serviceCaller(
  withLoginRedirect(withStyles(s)(UserThankYouAssignmentAddPageInner))
);
